// Older catalog imports have no saved duration. Read the full streaming asset's
// metadata without playing it; the audition window must never supply this value.
export const sourceAudioDuration = url => new Promise((resolve, reject) => {
  const audio = new Audio();
  let timer;
  const finish = (error, duration) => {
    clearTimeout(timer);
    audio.onloadedmetadata = null;
    audio.onerror = null;
    audio.removeAttribute('src');
    audio.load();
    if (error) reject(error); else resolve(duration);
  };
  audio.preload = 'metadata';
  audio.onloadedmetadata = () => {
    const duration = Number(audio.duration);
    finish(Number.isFinite(duration) && duration > 0 ? null : new Error('Audio length unavailable'), duration);
  };
  audio.onerror = () => finish(new Error('Audio metadata could not load'));
  timer = setTimeout(() => finish(new Error('Audio metadata timed out')), 15000);
  audio.src = url;
  audio.load();
});
